module.exports = __webpack_public_path__ + "img/esc_2_act_2.10686a16.png";